// extracted by mini-css-extract-plugin
export default {"loader-item":"loader-item--eEj0x","loaderItem":"loader-item--eEj0x","loader":"loader--lXGn8"};